/* eslint-disable */

import ClipboardJS from 'clipboard';

jQuery(function ($) {
  $('.clipboard').on('click', function () {
    const clipboardId = $(this).attr('id');
    const clipboard = new ClipboardJS('#' + clipboardId);
    const $wrapper = $('.course-sharing-modal .wrapper.social-media');
    
    clipboard.on('success', function (e) {
      const $button = $(e.trigger);
      const originalText = $button.text();
      
      // Muda o texto do botão
      $button.text('Copiado!').addClass('copied');
      
      // Mostra mensagem discreta
      showCopyMessage($wrapper);
      
      // Restaura o texto original após 2 segundos
      setTimeout(() => {
        $button.text(originalText).removeClass('copied');
      }, 2000);

      console.info('Action:', e.action);
      console.info('Text:', e.text);
      console.info('Trigger:', e.trigger);

      e.clearSelection();
    });

    clipboard.on('error', function (e) {
      console.error('Action:', e.action);
      console.error('Trigger:', e.trigger);
    });
  });

  // Função para mostrar mensagem discreta de sucesso
  function showCopyMessage($wrapper) {
    // Remove mensagem existente se houver
    $('.copy-success-message').remove();
    
    // Cria nova mensagem
    const $message = $('<div class="copy-success-message">Link copiado com sucesso!</div>');
    $wrapper.append($message);
    
    // Anima a entrada
    setTimeout(() => {
      $message.addClass('show');
    }, 10);
    
    // Remove após 3 segundos
    setTimeout(() => {
      $message.removeClass('show');
      setTimeout(() => {
        $message.remove();
      }, 300);
    }, 4000);
  }
});

jQuery(function ($) {
  $('.Course-calendar a').on('click', function () {
    const calendar = $('#calendario-do-curso');

    $('html,body').animate({ scrollTop: (calendar.offset().top - 200) });
  });

  $('.course-sharing-button').on('click', function () {
    $('.course-sharing-modal').removeAttr('style');
  });

  $('.course-sharing-modal-close').on('click', function () {
    $('.course-sharing-modal').attr('style', 'display:none;');
  });

  $('.course-sharing-email').on('click', function () {
    $('.course-sharing-modal .wrapper.social-media').attr('style', 'display:none;');
    $('.course-sharing-modal .wrapper.email').removeAttr('style');
  });

  $('.course-sharing-modal-back').on('click', function () {
    $('.course-sharing-modal .wrapper.social-media').removeAttr('style');
    $('.course-sharing-modal .wrapper.email').attr('style', 'display:none;');
  });
});
